var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('db-row',{staticClass:"zoom-wrapper",class:_vm.zoomClass,attrs:{"valign":"middle","align":"center"},on:{"click":_vm.close}},[_c('img',{attrs:{"id":_vm.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }